var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadBigArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload Big Arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.80381 8.4116H10.5119V16.4452C10.5119 17.2603 11.1728 17.9203 11.987 17.9203H16.0134C16.8276 17.9203 17.4885 17.2603 17.4885 16.4452V8.4116H20.1957C20.6442 8.4116 21.0474 8.14157 21.2198 7.72711C21.3905 7.31435 21.2955 6.83717 20.9786 6.5203L14.783 0.323887C14.3503 -0.107962 13.6492 -0.107962 13.2156 0.323887L7.02099 6.5203C6.70405 6.83717 6.6091 7.31353 6.78068 7.72711C6.95303 8.14075 7.35532 8.4116 7.80381 8.4116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.0491 11.4229C25.3149 11.4229 24.7194 12.0185 24.7194 12.7534V18.3167C24.7194 19.9833 23.3627 21.3391 21.6961 21.3391H6.30357C4.63692 21.3391 3.28115 19.9833 3.28115 18.3167V12.7534C3.28115 12.0185 2.6847 11.4229 1.95063 11.4229C1.2157 11.4229 0.620117 12.0185 0.620117 12.7534V18.3168C0.620117 21.4506 3.16967 24.0002 6.30357 24.0002H21.6961C24.83 24.0002 27.3796 21.4506 27.3796 18.3168V12.7534C27.3796 12.0185 26.784 11.4229 26.0491 11.4229Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBigArrow);
export default __webpack_public_path__ + "static/media/UploadBigArrow.7dc219705532d6be20384d0638fbcb70.svg";
export { ForwardRef as ReactComponent };